(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServantCustom', ServantCustom);

    ServantCustom.$inject = ['$resource', 'ENV'];

    function ServantCustom($resource, ENV) {


        var findServantsByCompany = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/servants-by-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var findServantsByServiceItem = function (serviceItemId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/servants-by-service-item/' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var serviceItemScheduleByServantId = function (servantId) {
            var resourceUrl = ENV.API_BASE_URL + 'api/service-by-servant/' + servantId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var saveScheduleList = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/service-servant-schedule-list';
            return $resource(resourceUrl, {}, {
                    'update': {method: 'PUT', isArray: true}
                }
            );
        };

        var findServantByCurrentUser = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/find-servant-by-current-user';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var updateServantService = function (serviceid, servantid) {
            var resourceUrl = ENV.API_BASE_URL + 'api/update-service-servant-priceinfo/' + serviceid + '/' + servantid;
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST'}
                }
            );
        }

        var getServantsHaveServicesByCurrentCompany = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-servants-have-services-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        return {
            findServantsByCompany: findServantsByCompany,
            findServantsByServiceItem: findServantsByServiceItem,
            serviceItemScheduleByServantId: serviceItemScheduleByServantId,
            saveScheduleList: saveScheduleList,
            findServantByCurrentUser: findServantByCurrentUser,
            updateServantService: updateServantService,
            getServantsHaveServicesByCurrentCompany: getServantsHaveServicesByCurrentCompany

        };
    }
})();
